import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { CalendarClock, ChevronRight } from "lucide-react";

const DAY = 86400000;

export const TodayJourney = ({ settings, itinerary = [] }) => {
  const { t, L } = useLang();
  const navigate = useNavigate();
  const { tripStartDate, tripEndDate } = settings || {};
  if (!tripStartDate || !tripEndDate) return null;

  const start = new Date(tripStartDate + "T00:00:00");
  const end = new Date(tripEndDate + "T00:00:00");
  if (isNaN(start) || isNaN(end)) return null;

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (today < start || today > end) return null; // only during the trip

  const dayNumber = Math.round((today - start) / DAY) + 1;
  const entry = itinerary.find((it) => {
    const from = Number(it.dayFrom);
    const to = Number(it.dayTo);
    return !isNaN(from) && !isNaN(to) && dayNumber >= from && dayNumber <= to;
  });
  if (!entry) return null;

  return (
    <section data-testid="today-journey" className="animate-fade-up">
      <div className="mb-5 flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-2xl bg-[#0A192F] text-[#E9CE7D]">
          <CalendarClock size={18} strokeWidth={1.75} />
        </span>
        <div>
          <h2 className="font-display text-xl font-bold tracking-tight text-[#0A192F] leading-none">
            {t("today.title")}
          </h2>
          <p className="mt-1 text-xs text-slate-500">
            {t("today.day")} {dayNumber} · {L(entry.title)}
          </p>
        </div>
      </div>

      <div className="maqam-card p-6">
        <ul className="space-y-3.5">
          {(entry.items || []).map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-[#D4AF37]" />
              <span className="text-[15px] leading-snug text-[#0A192F]">{L(item)}</span>
            </li>
          ))}
        </ul>
        <button
          onClick={() => navigate("/section/itinerary")}
          data-testid="today-view-full"
          className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[#0A192F] transition-colors hover:text-[#BCA054]"
        >
          {t("sec.itinerary.title")}
          <ChevronRight size={16} />
        </button>
      </div>
    </section>
  );
};
